import { deepEqual, evaluate } from "mathjs";

const isNumber = (str : string) => {
    try {
        const value = evaluate(str);

        if (isNaN(value)) {
            return false
        } else {
            return true
        }
        
    } catch (error) {
        return false
    }
}

export const isDiscretSet = (str: string) => {
    
    try {
        var strLeft = str.charAt(0);
        var strRight = str.charAt(str.length-1);

        if (strLeft !== '{' || strRight !== '}') {
            return { 
                ok: false, 
                title: '¡Cuidado!',
                msg: 'Los extremos del conjunto son: { y }'
            }
        }

        var strCenter = str.substring(1,str.length-1);
        var strArray = strCenter.split(",");

        const arreglo =[]

        for (var i = 0; i < strArray.length; i++) {
            arreglo.push(isNaN(evaluate(strArray[i])))
        }

        const long = arreglo.filter(Boolean).length
        
        if (long === 0) {
            return { 
                ok: true, 
                title: 'Exito',
                msg: `${str} es un vector`
            }
        } else {
            return { 
                ok: false, 
                title: '¡Cuidado!',
                msg: 'No has ingresado una respuesta'
            }
        }
    } catch (error) {
        return { 
            ok: false, 
            title: '¡Cuidado!',
            msg: 'Tu respuesta no representa un vector'
        }
    }

}

export const isInterval = (int: string) => {

    const interval = int.replace(/inf/g,'1e309').replace(/ /g,'');

    try {
        const leftInt = interval.charAt(0);
        const rightInt = interval.charAt(interval.length-1);
        const tupla = interval.substring(1,interval.length-1).split(",");

        if (
            (leftInt !== '(' && leftInt !== '[') ||
            tupla.length !== 2 ||
            (rightInt !== ')' && rightInt !== ']')
        ) {
            return { 
                ok: false, 
                title: 'Error en el formato',
                msg: 'Un intervalo es: (a,b), (a,b], [a,b), [a,b]'
            }
        }

        const leftIsNumber = isNumber(tupla[0]);
        const rightIsNumber = isNumber(tupla[1]);

        if (!leftIsNumber || !rightIsNumber) {
            return { 
                ok: false, 
                title: 'Error en las entradas',
                msg: 'Al menos una de las entradas no es un número'
            }
        }

        const leftNumber = evaluate(tupla[0]);
        const rightNumber = evaluate(tupla[1]);

        if (leftNumber >= rightNumber) {
            return { 
                ok: false, 
                title: 'Error en las entradas',
                msg: 'La primera entrada debe ser menor que la segunda'
            }
        }

        return { 
            ok: true, 
            title: 'Exito',
            msg: `${int.replace(/inf/g,'∞')} es un intervalo`
        }

    } catch (error) {
        return { 
            ok: false, 
            title: 'Cuidado',
            msg: 'Tu respuesta no representa un intervalo'
        }
    }
}

export const isSet = (set: string) => {
    const conjunto = set.replace(/inf/g,'1e309').replace(/ /g,'');

    var arraySet = conjunto.split("U"); 
    
    var arrayBoolean = [];
    for (let k = 0; k < arraySet.length; k++) {
        arrayBoolean.push(isInterval(arraySet[k]).ok || isDiscretSet(arraySet[k]).ok);
    }
    
    const lengthArrayBooleanTrue = arrayBoolean.filter(Boolean).length;
    const lengthArrayBoolean = arrayBoolean.length;

    if (lengthArrayBooleanTrue === lengthArrayBoolean) {
        return { 
            ok: true, 
            title: 'Exito',
            msg: `${set.replace(/inf/g,'∞')} es un conjunto`
        }
    } else {
        return { 
            ok: false, 
            title: 'Error',
            msg: `${set.replace(/inf/g,'∞')} no es un conjunto`
        }
    }  
}

export const equalNumberSubsets = (setDataBase: string, setUser: string) => { 
    var conjuntoBaseDatos = setDataBase.replace(/inf/g,'1e309').replace(/ /g,'');
    var conjuntoUsuario = setUser.replace(/inf/g,'1e309').replace(/ /g,'');

    var arraySetDataBase = conjuntoBaseDatos.split("U"); 
    var arraySetUser = conjuntoUsuario.split("U");

    if (arraySetDataBase.length === arraySetUser.length) {
        return { 
            ok: true, 
            title: 'Exito',
            msg: 'Ambos conjuntos tienen el mismo número de subconjuntos'
        }
    } else {
        return { 
            ok: false, 
            title: 'Error',
            msg: `El conjunto solución tiene ${arraySetDataBase.length} subconjunto(s)`
        }
    }
}

export const subset = (setDataBase: string, setUser: string) => {

    try {
        var conjuntoBaseDatos = setDataBase.replace(/inf/g,'1e309').replace(/ /g,'');
        var conjuntoUsuario = setUser.replace(/inf/g,'1e309').replace(/ /g,'');

        var arraySetDataBase = conjuntoBaseDatos.split("U"); 
        var arraySetUser = conjuntoUsuario.split("U");

        var arrayBoolean = [];
        for (var k = 0; k < arraySetDataBase.length; k++) {
            for (var l = 0; l < arraySetUser.length; l++) {
                const intDataBase = arraySetDataBase[k];
                const leftIntDataBase = intDataBase.charAt(0);
                const rightIntDataBase = intDataBase.charAt(intDataBase.length-1);
                const tuplaDataBase = intDataBase.substring(1,intDataBase.length-1).split(",");

                const intUser = arraySetUser[l];
                const leftIntUser = intUser.charAt(0);
                const rightIntUser = intUser.charAt(intUser.length-1);
                const tuplaUser = intUser.substring(1,intUser.length-1).split(",");


                const arregloNumericoUno = evaluate(tuplaDataBase);
                const arregloNumericoDos = evaluate(tuplaUser);

                //reordenar los números de menor a mayor
                arregloNumericoUno.sort(function(a: number, b: number) {
                    return a - b;
                });
                arregloNumericoDos.sort(function(a: number, b: number) {
                    return a - b;
                });

                const conjuntosIguales = deepEqual(arregloNumericoUno, arregloNumericoDos);

                if (
                    leftIntDataBase === leftIntUser &&
                    rightIntDataBase === rightIntUser &&
                    conjuntosIguales
                ) {
                    arrayBoolean.push(true);
                } else {
                    arrayBoolean.push(false);
                }
            }
        }

        if (arrayBoolean.filter(Boolean).length === arraySetUser.length) {
            return { 
                ok: true, 
                title: 'Exito',
                msg: 'Tu conjunto es subconjunto de la solución'
            }
        } else {
            return { 
                ok: false, 
                title: 'Error',
                msg: 'Te has equivocado en al menos un conjunto'
            }
        }
    } catch (error) {
        console.log(error)
        return { 
            ok: false, 
            title: 'Error',
            msg: 'Te has equivocado en al menos un conjunto'
        }
    }
}

